module.exports = __webpack_public_path__ + "am.svg?1fd89addafc345e49acdd16000d3c632";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/am.svg
// module id = 989
// module chunks = 27